import { render, staticRenderFns } from "./ChainLog.vue?vue&type=template&id=2babbc63"
import script from "./ChainLog.vue?vue&type=script&lang=js"
export * from "./ChainLog.vue?vue&type=script&lang=js"
import style0 from "./ChainLog.vue?vue&type=style&index=0&id=2babbc63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports